import { Flex, Image, Heading, Box } from '@chakra-ui/react'
import Amplify from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { EMAIL_FORM_VIEW } from './email.config'
import EmailInput from './email.input'
import OTPNumberInput from '../otp-input'
import greneLogo from '../../../assets/images/grene-logo.png'
import { VIEW_MODE } from './../login.util'

export function EmailOTPLogin({ setLoginViewMode }) {
	const [view, setView] = useState(EMAIL_FORM_VIEW.EMAIL_VIEW)
	const [user, setuser] = useState(null)

	useEffect(() => {
		Amplify.configure({
			Auth: {
				mandatorySignIn: true,
				userPoolId: process.env.REACT_APP_EMAIL_USER_POOL_ID,
				identityPoolId: process.env.REACT_APP_EMAIL_IDENTITY_POOL_ID,
				userPoolWebClientId:
					process.env.REACT_APP_EMAIL_WEB_NO_SECRETE_CLIENT_ID,
				region: process.env.REACT_APP_EMAIL_AWS_REGION,
			},
			Analytics: {
				disabled: true,
			},
		})
	}, [])

	const onValidationSuccess = () => {
		setLoginViewMode(VIEW_MODE.ORG)
	}

	return (
		<Box
			bg='white'
			boxShadow='0px 4px 4px rgba(0, 0, 0, 0.25)'
			borderRadius='20px'
			minW='28rem'
			padding='3em 0em'
			color='black'
		>
			<Flex
				flex={1}
				h='full'
				alignItems='center'
				justifyContent='center'
				flexDir='column'
				gap='1rem'
			>
				<Image src={greneLogo} maxW='64px' />

				{view === EMAIL_FORM_VIEW.EMAIL_VIEW ? (
					<EmailInput
						onSendOtpSuccess={(user, view) => {
							setView(view)
							setuser(user)
						}}
						setLoginMode={setLoginViewMode}
					/>
				) : view === EMAIL_FORM_VIEW.OTP_VIEW ? (
					<OTPNumberInput
						isEmailView={true}
						user={user}
						setView={setView}
						onValidationSuccess={onValidationSuccess}
					/>
				) : null}
			</Flex>
		</Box>
	)
}
